import { Popconfirm, Button } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

DeleteButton.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  confirmText: PropTypes.string,
  disabled: PropTypes.bool
}

export function DeleteButton ({
  onClick,
  confirmText = "Confirma que deseas eliminar este elemento",
  style,
  disabled = false,
  ...props
}) {
  return (
    <Popconfirm
      disabled={disabled}
      title={confirmText}
      onConfirm={onClick}
      okText="Eliminar"
      cancelText="Cancelar">
      <Button
        disabled={disabled}
        style={{ float: "right", ...style }}
        shape="circle"
        icon={<DeleteOutlined/>}
        {...props} />
    </Popconfirm>
  )
}
